import React from 'react'
import { withRouter } from 'react-router-dom';
import withAuthentication from './identity/withAuthentication';

import {Row, Col, Input} from 'react-materialize'

import * as routes from '../config/routes';
import * as api from '../api'
import * as welcomeCopy from '../assets/copy/welcome'
import * as generalCopy from '../assets/copy/general'

// require('../assets/styles/materialize.css');
// require('../assets/styles/style.css');

class WelcomeForm extends React.Component {
  state = {
    form: {},
    step: 1
  }

  constructor (props) {
    super(props)
    this.submitForm = this.submitForm.bind(this);
  }

  submitForm(e) {
    e.preventDefault()
    var formBody = this.state.form
    api.makeApiPost(routes.INTAKE_FORM, formBody, (res, status) => {
      if (res.err || status !== 200) {
        this.setState({step: 3})
      } else {
        this.setState({form: {}})
        this.setState({step: 2})
      }
    })
  }

  checkboxHelper(event) {
    var el
    if (event)
      el = event.target
    if (el) 
      this.state.form[el.value]= el.checked
  }

  valueHelper(event) {
    var el
    if (event)
      el = event.target
    if (el) {
      if (!(el.value === "")) {
        this.state.form[el.id]= el.value
      }
    }
  }

  render() {
    return (
      <div class="full-height valign-wrapper">
        <div className="container ">
          <div className="section">
            { (this.state.step === 1) ? (
              <div className="card-panel">

                <Col s={12} >
                  <br/>
                  <h5 className=" secondary-color-1-text question-title">
                    {generalCopy.welcome} 
                  </h5>
                  <p>{generalCopy.excited}</p>
                  <hr className="center-align secondary-color-2 secondary-color-2-text"/>
                  <p>{welcomeCopy.housekeepingIntro}</p>
                  {
                    welcomeCopy.housekeeping.map((instruction, index) => {
                      return <p><label><input key={index} onChange={el => this.checkboxHelper(el)} type="checkbox" className="filled-in" value="wireframes"/><span className="dark-color-2-text"> <strong>{instruction['title']}</strong> {instruction['description']} </span></label></p>
                    })
                  }  
                  <br/>
                  <p>{welcomeCopy.agreementIntro}</p> 
                  {
                    welcomeCopy.agreement.map((instruction, index) => {
                      return <p><label><input key={index} onChange={el => this.checkboxHelper(el)} type="checkbox" className="filled-in" value="wireframes"/><span className="dark-color-2-text"> <strong>{instruction['title']}</strong> {instruction['description']} </span></label></p>
                    })
                  }                    
                </Col>

                <form onSubmit={this.submitForm}> 
                  <p className="center-align"> 
                    <Input required defaultValue = {this.state.form['name']} id='name' type="text" label={generalCopy.formLabelName} onChange={el => this.valueHelper(el)}/>
                    <Row>
                      <button id="submit" className="btn">{generalCopy.confirm}</button>
                    </Row>
                  </p>
                </form>
              </div>
              ) : false 
            }


          { (this.state.step === 2) ? (
           <div className="card-panel">
              <br/>
              <h5 className=" secondary-color-1-text question-title"> {generalCopy.thanks}</h5>
              <hr className="center-align secondary-color-2 secondary-color-2-text"/>

              <Row>
                <p className="mid-size-h center-align">{generalCopy.thanksDetail}</p>
              </Row>
           </div>
           ) : false 
          }


          { (this.state.step === 3) ? (
            <div className="card-panel">
              <br/>
              <h5 className=" secondary-color-1-text question-title"> {generalCopy.problem}</h5>
              <hr className="center-align secondary-color-2 secondary-color-2-text"/>

              <Row>
                <p className="mid-size-h center-align">{generalCopy.problemDetail}</p>
              </Row>

              <Row>
                <p className="center-align">
                  <a onClick={() => {this.setState({step:3})}} className="btn" >{generalCopy.tryAgain}</a>
                </p>
              </Row>
            </div>
           ) : false
          }
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withAuthentication(WelcomeForm));


// WEBPACK FOOTER //
// ./src/components/WelcomeForm.js